import { useQuery } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import { useAxiosClientsContextProvider } from 'shared/axios/axios-clients-provider';

import { ReadFaultsHistoryFiltersQuery } from 'features/faults-history/domain/models/read-faults-history-filters-query';
import { ReadFaultsHistoryFiltersResponse } from 'features/faults-history/domain/models/read-faults-history-filters-response';
import { ReadFaultsHistoryQuery } from 'features/faults-history/domain/models/read-faults-history-query';
import ReadFaultsResponse from 'features/faults-history/domain/models/read-faults-response';

const faultsHistoryBaseUrl = '/api/v1/FaultsHistory';

enum FaultsHistoryQueryPaths {
  ReadFaultsHistory = 'ReadFaultsHistory',
  ReadFaultsHistoryFilters = 'ReadFaultsHistoryFilters',
}

const readFaultsHistory = async (axiosInstance: AxiosInstance, body: ReadFaultsHistoryQuery): Promise<ReadFaultsResponse> => {
  const response = await axiosInstance.post(`${faultsHistoryBaseUrl}/${FaultsHistoryQueryPaths.ReadFaultsHistory}`, body);
  return response.data;
};

const readFaultsHistoryFilters = async (
  axiosInstance: AxiosInstance,
  body: ReadFaultsHistoryFiltersQuery,
): Promise<ReadFaultsHistoryFiltersResponse> => {
  const response = await axiosInstance.post(`${faultsHistoryBaseUrl}/${FaultsHistoryQueryPaths.ReadFaultsHistoryFilters}`, body);
  return response.data;
};

export const useReadFaultsHistory = (body: ReadFaultsHistoryQuery) => {
  const { authenticatedInstance } = useAxiosClientsContextProvider();
  return useQuery({
    queryKey: [FaultsHistoryQueryPaths.ReadFaultsHistory, body],
    queryFn: () => readFaultsHistory(authenticatedInstance, body),
  });
};

export const useLazyReadFaultsHistoryFilters = (body: ReadFaultsHistoryFiltersQuery) => {
  const { authenticatedInstance } = useAxiosClientsContextProvider();
  return useQuery({
    queryKey: [FaultsHistoryQueryPaths.ReadFaultsHistoryFilters, body],
    queryFn: () => readFaultsHistoryFilters(authenticatedInstance, body),
    enabled: false,
  });
};
